<style>
</style>
<template>
<div class="container-fluid">
    <div class="card animated fadeIn">
        <b-form @submit.prevent="updateAccount()">
            <b-row>
                <b-col sm=8>
                    <b-card>
                        <div slot="header">
                            <strong>Edit Account:</strong> {{account.name}}
                        </div>
                        <div>
                            <div>
                                <div>
                                    <b-form-group label="Name:" label-for="name" :label-cols-sm="2">
                                        <b-form-input type="text" v-model="account.name" v-validate="'required'" id="name" name="name" :state="validateState('name')" :readonly=!readonly></b-form-input>
                                        <div v-if="submitted && verrors.has('name')" class="invalid-feedback">{{ verrors.first('name') }}</div>
                                    </b-form-group>
                                    <b-form-group label="Token:" label-for="name" :label-cols-sm="2">
                                        <b-form-input type="text" v-model="account.token" readonly></b-form-input>
                                    </b-form-group>
                                </div>
                            </div>
                        </div>
                    </b-card>
                </b-col>
                <b-col sm=4>
                    <b-card>
                        <div slot="header">
                            <strong>Details</strong>
                        </div>
                        Info goes here
                    </b-card>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm=8>
                    <div class="text-center">
                        <!-- TODO only activate when dirty -->
                        <button :disabled="verrors.any()" class="btn btn-primary">Save</button>
                    </div>
                </b-col>
            </b-row>
        </b-form>
    </div>
</div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { vm } from '@/app.js'

export default {
    components: {
        Multiselect,
    },
    data() {
        return {
            account: {},
            submitted: false,
        };
    },
    // https://github.com/shentao/vue-multiselect/issues/263
    watch: {},
    created() {
        let uri = `/api/accounts/${this.$route.params.id}`;
        axios.get(uri).then((response) => {
            this.account = response.data.data;
        });

    },
    computed: {
        optionsArray() {
            return Object.keys(this.options).map(i => this.options[i]);
        },
        readonly() {
            return this.$can('account', 'edit')
        },
    },
    methods: {
        validateState(ref) {
            if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                return !this.verrors.has(ref)
            }
            return null
        },
        updateAccount() {
            this.submitted = true;
            this.$validator.validate().then(valid => {
                if (valid) {
                    let uri = `/api/accounts/${this.account.id}`;
                    axios.patch(uri, this.account)
                        .then((response) => {
                            if (response.data.success === true) {
                                console.log(response.data);
                                this.makeToast('info', 'account updated.');
                                setTimeout(function () {
                                    window.location.href = '/#/accounts';
                                }, 1000);
                            } else {
                                console.log(error.response.data.message);
                                this.makeToast('danger', 'Unable to update account.');
                            }
                        })
                        .catch(function (error) {
                            if (error.response && error.response.status == 422) {
                                // makeToast('danger', 'Unable to update account.');
                                // alert(this.prettyJSON(error.response.data.errors));
                                const errors = error.response.data.errors;
                                vm.$setErrorsFromResponse(error.response.data);

                            }
                        });

                }
            });
        },
        makeToast(variant = null, message = null) {
            this.$bvToast.toast(message, {
                // title: `account Updated ${variant || 'default'}`,
                title: `Notification:`,
                variant: variant,
                toaster: 'b-toaster-top-center',
                solid: true
            });
            // toast.show();
        },
    }

}
</script>
